export default (val: number) => {
    let offset = 0;
    if (val < -7) offset -= 24;
    else if (val < 0) offset -= 12;
    if (val >= 7) offset += 12;
    val += 14;
    let diat = val % 7;
    switch (diat) {
        case 0:
            offset += 0;
            break;
        case 1:
            offset += 2;
            break;
        case 2:
            offset += 4;
            break;
        case 3:
            offset += 5;
            break;
        case 4:
            offset += 7;
            break;
        case 5:
            offset += 9;
            break;
        case 6:
            offset += 11;
            break;
        default:
            offset += 0;
    }

    return offset;
};
